
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * CommissionCalculationType enum
 */
class CommissionCalculationType {
  /**
   * Initialize enum with a given value
   * @param {CommissionCalculationType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof CommissionCalculationType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!CommissionCalculationType}
   * @param {!CommissionCalculationType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CommissionCalculationType)) {
      throw new TypeError('Instance of CommissionCalculationType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!CommissionCalculationType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!CommissionCalculationType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === CommissionCalculationType.FOREX.value) {
      return 'FOREX'
    }
    if (this.value === CommissionCalculationType.CFD.value) {
      return 'CFD'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!CommissionCalculationType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!CommissionCalculationType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!CommissionCalculationType} Created enum
   */
  static fromObject (other) {
    return new CommissionCalculationType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
CommissionCalculationType.FOREX = new CommissionCalculationType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
CommissionCalculationType.CFD = new CommissionCalculationType(0 + 1)

export { CommissionCalculationType };

/**
 * Fast Binary Encoding CommissionCalculationType field model
 */
class FieldModelCommissionCalculationType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelCommissionCalculationType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelCommissionCalculationType}
   * @param {CommissionCalculationType=} defaults Default value, defaults is new CommissionCalculationType()
   * @returns {!CommissionCalculationType} Result value
   */
  get (defaults = new CommissionCalculationType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new CommissionCalculationType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelCommissionCalculationType}
   * @param {!CommissionCalculationType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelCommissionCalculationType };
